var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLaunchFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M15.784 15.843s2.855-2.855 3.831-3.829c3.063-3.063 1.531-9.191 1.531-9.191s-6.128-1.532-9.191 1.532c-2.29 2.29-3.816 3.867-3.816 3.867s-3.843-.804-6.14 1.494l12.254 12.255c2.298-2.298 1.531-6.128 1.531-6.128m-1.502-8.985a2 2 0 0 1 2.828 0 2 2 0 1 1-2.828 0M2.969 20.969s3 0 5-2l-3-3c-2 1-2 5-2 5"
})));
export default SvgLaunchFill;